import { FC } from "react";
import { useI18n } from "../../hooks/useTranslations";
import { useDueDatesApi } from "../../http/dueDates/api";
import { formatDate } from "../../types/utils";
import HistoryDialog from "../ui/HistoryDialog";

import VersionDialog from "../ui/VersionDialog";

type DueDateHistroryDialogProps = {
  itemToShowVersionsId: string;
  itemVersionToShowVersions: number;
  onClose: () => void;
};

const DueDateHistroryDialog: FC<DueDateHistroryDialogProps> = ({
  itemToShowVersionsId,
  itemVersionToShowVersions,
  onClose,
}) => {
  const i18n = useI18n();
  const dueDatesApi = useDueDatesApi();

  return (
    <HistoryDialog
      title={i18n.t.dueDates.versions}
      lastVersion={itemVersionToShowVersions}
      entityId={itemToShowVersionsId}
      getEntityVersionHook={dueDatesApi.getAdminDueDateVersion}
      getHistory={dueDatesApi.getAdminDueDateHistory}
      onClose={onClose}
      renderForm={(headers, dataVersion) => (
        <>
          <VersionDialog.Table headers={headers}>
            {(dataVersion.current?.car?.id ?? null) !== (dataVersion.next.car?.id ?? null) && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.cars.singular}
                  value={
                    dataVersion.current?.car?.currentPlateNumber ||
                    dataVersion.current?.car?.vehicleIdentificationNumber
                  }
                  edited={
                    dataVersion.next?.car?.currentPlateNumber || dataVersion.next?.car?.vehicleIdentificationNumber
                  }
                />
              </tr>
            )}
            {(dataVersion.current?.type?.id ?? null) !== (dataVersion.next.type?.id ?? null) && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.type}
                  value={dataVersion.current?.type?.name}
                  edited={dataVersion.next?.type?.name}
                />
              </tr>
            )}
            {dataVersion.current?.date != dataVersion.next.date && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.date}
                  value={dataVersion.current && formatDate(dataVersion.current?.date!, i18n.language)}
                  edited={formatDate(dataVersion.next?.date!, i18n.language)}
                />
              </tr>
            )}
            {dataVersion.current?.isSettled != dataVersion.next.isSettled && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.isSettled}
                  value={dataVersion.current.isSettled}
                  edited={dataVersion.next?.isSettled}
                />
              </tr>
            )}
            {(dataVersion.current?.visibleToUser?.id ?? "") != (dataVersion.next.visibleToUser?.id ?? "") && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.visibleToUser}
                  value={dataVersion.current.visibleToUser?.fullName ?? ""}
                  edited={dataVersion.next?.visibleToUser?.fullName ?? ""}
                />
              </tr>
            )}
          </VersionDialog.Table>
        </>
      )}
    />
  );
};

export default DueDateHistroryDialog;
